



































































import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {},
})
export default class Home extends Vue {
  public active = 2;
  // public mounted() {}
}
